module.exports = __webpack_public_path__ + "img/tasks-green.89793370.svg";